import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-17d81623"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "swiper-container"
};
var _hoisted_2 = {
  ref: "btnPrevRef",
  class: "swiper-button-prev btn-swiper-control"
};
var _hoisted_3 = {
  ref: "btnNextRef",
  class: "swiper-button-next btn-swiper-control"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ExcellentWorkCard = _resolveComponent("ExcellentWorkCard");
  var _component_SwiperSlide = _resolveComponent("SwiperSlide");
  var _component_Swiper = _resolveComponent("Swiper");
  var _component_WorkDetail = _resolveComponent("WorkDetail");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, null, 512), _createElementVNode("div", _hoisted_3, null, 512), _ctx.btnPrevRef && _ctx.btnNextRef ? (_openBlock(), _createBlock(_component_Swiper, {
    key: 0,
    modules: _ctx.modules,
    "slides-per-view": 4,
    "space-between": 0,
    autoplay: true,
    navigation: {
      prevEl: _ctx.btnPrevRef,
      nextEl: _ctx.btnNextRef
    },
    loop: true
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item) {
        return _openBlock(), _createBlock(_component_SwiperSlide, {
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_ExcellentWorkCard, {
              onSelect: _ctx.onCardSelect,
              work: item
            }, null, 8, ["onSelect", "work"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["modules", "navigation"])) : _createCommentVNode("", true), _ctx.selectedCard ? (_openBlock(), _createBlock(_component_WorkDetail, {
    creation: _ctx.selectedCard,
    key: _ctx.selectedCard.id
  }, null, 8, ["creation"])) : _createCommentVNode("", true)]);
}